"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = require("moment");
var moment = require("moment-timezone");
var date_const_1 = require("../const/date.const");
var message_const_1 = require("../const/message.const");
var globals_1 = require("../globals/globals");
function reformatDateTime(value, targetFormat, timezone) {
    if (targetFormat === void 0) { targetFormat = date_const_1.DATE_FORMAT.default; }
    if (timezone === void 0) { timezone = date_const_1.TIME_ZONE.default; }
    var dateTime = moment(value);
    return dateTime.isValid()
        ? moment
            .utc(value)
            .tz(timezone)
            .format(targetFormat)
        : message_const_1.FALLBACK_MESSAGE.dash;
}
exports.reformatDateTime = reformatDateTime;
function formatDate(value, dateFormat) {
    if (dateFormat === void 0) { dateFormat = date_const_1.DATE_FORMAT.default; }
    var utcString = globals_1.getUtcString(value);
    return moment.utc(utcString).format(dateFormat);
}
exports.formatDate = formatDate;
function formatUtc(value, dateFormat, timezone) {
    if (dateFormat === void 0) { dateFormat = date_const_1.DATE_FORMAT.default; }
    if (timezone === void 0) { timezone = date_const_1.TIME_ZONE.default; }
    var utcString = globals_1.getUtcString(value);
    return moment
        .utc(utcString)
        .tz(timezone)
        .format(dateFormat);
}
exports.formatUtc = formatUtc;
function toUtcDateRange(dateRange) {
    var fromOffsetLocal = moment_1.parseZone(dateRange.from)
        .local()
        .utcOffset();
    var toOffsetLocal = moment_1.parseZone(dateRange.to)
        .local()
        .utcOffset();
    return {
        from: moment_1.parseZone(dateRange.from)
            .utcOffset(fromOffsetLocal, true)
            .startOf('day')
            .utc()
            .format(),
        to: moment_1.parseZone(dateRange.to)
            .utcOffset(toOffsetLocal, true)
            .endOf('day')
            .utc()
            .format(),
    };
}
exports.toUtcDateRange = toUtcDateRange;
